import { render, staticRenderFns } from "./customerClubSettings.vue?vue&type=template&id=b6b0f550&scoped=true"
import script from "./customerClubSettings.vue?vue&type=script&lang=js"
export * from "./customerClubSettings.vue?vue&type=script&lang=js"
import style0 from "./customerClubSettings.vue?vue&type=style&index=0&id=b6b0f550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b0f550",
  null
  
)

export default component.exports